<div class="card space-y-3">
  <h2 class="text-xs font-bold text-stone-400 uppercase tracking-wider">Justificatif</h2>

  @if (lien && nom) {
    <!-- Tuile fichier : icône selon le format, nom lisible, et l'ouverture dans un onglet. -->
    <a [href]="lien" target="_blank" rel="noopener"
       class="flex items-center gap-3 p-3 rounded-xl border-2 border-dashed border-stone-200">
      <span class="flex items-center justify-center w-11 h-11 rounded-lg bg-primary-50 text-primary-600 shrink-0">
        <span class="material-icons text-xl">{{ estPdf ? 'picture_as_pdf' : 'image' }}</span>
      </span>
      <span class="min-w-0 flex-1">
        <span class="block text-sm font-medium truncate" style="color: #0a4342;">{{ nom }}</span>
        <span class="block text-xs text-stone-400">Ouvrir dans un nouvel onglet</span>
      </span>
      <span class="material-icons text-stone-300 transition-colors shrink-0">open_in_new</span>
    </a>
  } @else {
    <!-- Absence : une ligne discrète. -->
    <p class="flex items-center gap-2 text-sm text-stone-400 justify-center border-2 border-dashed border-stone-200 rounded-xl py-4">
      <span class="material-icons text-base">description</span>
      {{ message || 'Aucun justificatif' }}
    </p>
  }
</div>
